import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import Catalogs from '../catalogs'
const model = (payload) => ({
  // columns
  id: payload.id,
  code: payload.code,
  branch_id: payload.branch_id
})
var crud = new Crud('Locations', model)
var catalogs = new Catalogs()

Vue.use(Vuex)

const state = {
  ...crud.state,
  ...catalogs.state,
  catalog: {
  },
  locations: []
}

const mutations = {
  ...crud.mutations,
  ...catalogs.mutations
}

const actions = {
  ...crud.actions,
  ...catalogs.actions
}

const getters = {
  ...crud.getters,
  ...catalogs.getters,
  locations: state => state.locations
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
